import { TEXT_COLOURS, BRANDED_COLOURS, GRADIENTS } from '@constants';

export const MAX_IMAGES = 30;

export const FORM_FIELD = {
  IMAGES: {
    name: 'images',
    label: 'Current images',
    rules: [{ min: 1, max: MAX_IMAGES }],
  },
  BACKGROUND_COLOR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [...BRANDED_COLOURS, GRADIENTS['gradient-1'].key],
    rules: [{ required: true }],
  },
  TEXT_COLOR: {
    name: 'textColour',
    label: 'Text colour:',
    colors: [...TEXT_COLOURS],
    rules: [{ required: true }],
  },
  TITLE: {
    name: 'title',
    label: 'Module title:',
    placeholder: 'Enter a title for the gallery',
    rules: [{ required: true, message: 'Title is required' }],
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.IMAGES.name]: [],
  [FORM_FIELD.BACKGROUND_COLOR.name]: FORM_FIELD.BACKGROUND_COLOR.colors[0],
  [FORM_FIELD.TEXT_COLOR.name]: FORM_FIELD.TEXT_COLOR.colors[0],
};
